export class UserVisitsFilterParameters {
  constructor(public filterText: string = '', public page: number = 1, public pageSize: number = 10) {}
  public active?: boolean;
}
